'use strict';

const CreatorsStore = {
    storeName: 'CreatorsStore',

    initialState: {
        creatorsMap: {},
    },

    reducers: {
        ADD_CREATOR(state, creator) {
            return Object.assign({}, state, {
                creatorsMap: Object.assign({}, state.creatorsMap, {
                    [creator.id]: creator,
                }),
            });
        },
        ADD_CREATORS(state, creators) {
            return Object.assign({}, state, {
                creatorsMap: creators.reduce((creatorsMap, creator) => {
                    creatorsMap[creator.id] = creator;
                    return creatorsMap;
                }, Object.assign({}, state.creatorsMap)),
            });
        },
    },

    getters: {
        getCreatorsMap(state) {
            return state.creatorsMap;
        },
        getCreatorById(state, creatorId) {
            return state.creatorsMap[creatorId];
        },
    },
};

module.exports = CreatorsStore;



// WEBPACK FOOTER //
// ./assets/js/global/stores/CreatorsStore.es.js